/** The name the directory shows: first and last name, without stray spaces when either is empty. */
export const toDisplayName = (firstName?: string | null, lastName?: string | null): string =>
  [firstName?.trim(), lastName?.trim()].filter(Boolean).join(' ');

/** The name to show for a person: their stored display name, or first and last name while it is empty. */
export const employeeName = (
  employee?: { DisplayName?: string | null; FirstName?: string | null; LastName?: string | null } | null
): string => employee?.DisplayName?.trim() || toDisplayName(employee?.FirstName, employee?.LastName);
